import React, { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import PrivateHeader from "../../../components/PrivateHeader";
import { BarChart } from "react-feather";
import useGlobalStore from "src/store/useGlobalStore";
const RetailReports = lazy(() => import("./retailReports/index.js"));
const VendorReports = lazy(() => import("./vendorReports/index.js"));

const Reports = () => {
  const isRetail = useGlobalStore((state) => state.isRetail);

  if (isRetail) {
    return (
      <>
        <PrivateHeader header="Reports" Icon={BarChart} />
        <Helmet title="Spiffy Reports" />
        <Suspense fallback={<span />}>
          <RetailReports />
        </Suspense>
      </>
    );
  }

  return (
    <>
      <PrivateHeader header="Reports" Icon={BarChart} />
      <Helmet title="Spiffy Reports" />
      <Suspense fallback={<span />}>
        <VendorReports />
      </Suspense>
    </>
  );
};
export default Reports;
